import React from "react";

const AuditTrail = ({
  color = "#1581BA",
  fill = "white"
}: {
  color?: string;
  fill?: string;
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="16" height="16" rx="2" fill={color} />
    <mask
      id="mask0_1629_1299"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="16"
    >
      <rect width="16" height="16" fill={color} />
    </mask>
    <g mask="url(#mask0_1629_1299)">
      <path
        d="M10.667 13.9833V11.9833H8.66699V10.65H10.667V8.65H12.0003V10.65H14.0003V11.9833H12.0003V13.9833H10.667ZM2.66699 12V10.6667H7.38366C7.35033 10.9 7.33644 11.1222 7.34199 11.3333C7.34755 11.5444 7.36699 11.7667 7.40033 12H2.66699ZM2.66699 9.33334V8H9.10033C8.84477 8.17778 8.61421 8.37778 8.40866 8.60001C8.2031 8.82223 8.02255 9.06667 7.86699 9.33334H2.66699ZM2.66699 6.66667V5.33334H12.667V6.66667H2.66699ZM2.66699 4.00001V2.66667H12.667V4.00001H2.66699Z"
        fill={fill}
      />
    </g>
  </svg>
);

export default AuditTrail;
